import { useQuery } from '@tanstack/react-query';

import { getHasSpareParts } from '../../../apis/ilink';

interface UseHasSparePartsQueryProps {
  productId?: string;
}

export function useHasSparePartsQuery({ productId }: UseHasSparePartsQueryProps) {
  return useQuery({
    queryKey: ['has-spare-parts', productId],
    queryFn: () => getHasSpareParts(productId).catch(() => false),
    enabled: Boolean(productId),
    staleTime: Infinity,
  });
}
